import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon';
import Form from './components/Checkout/Form/Form';
import FareGroup from './components/FareGroup/FareGroup';
import { shirakEquipmentIcons } from 'components/HeaderEquipmentIcon/icons';
import { SportEquipment } from '@websky/core';
import CheckoutServicesV2 from '@websky/core/src/Checkout/components/Checkout/ServicesV2/ServicesV2';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const shirakRenderers = {
    BaggageIcon,
    renderHeaderEquipmentIcon: rfics => (shirakEquipmentIcons === null || shirakEquipmentIcons === void 0 ? void 0 : shirakEquipmentIcons[rfics]) || SportEquipment,
    CheckoutForm: Form,
    FareGroup,
    CheckoutServices: CheckoutServicesV2,
    CheckinServices: CheckinServicesV2
};
